import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import CardList from './CardContainer/CardList.jsx';
import FloatingChevron from './FloatingChevron';

import styles from './styles.js';

import { getCardProportions } from './methods';

import { getCardsLength } from '../../selectors';

class CardSlider extends Component {
    static propTypes = {
        cardType: PropTypes.string.isRequired,
        cardsLength: PropTypes.number.isRequired,
        containerClass: PropTypes.string,
        contentLoading: PropTypes.bool.isRequired,
        sliderDisabled: PropTypes.bool
    }

    state = {
        cardProportions: getCardProportions(this.props.cardType),
        xPosition: 0
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { contentLoading } = this.props;
        const { xPosition } = this.state;
        if (contentLoading !== nextProps.contentLoading) {
            return true;
        }
        if (xPosition !== nextState.xPosition) {
            return true;
        }
        return false;
    }

    handleSlideLeft = () => {
        const { cardProportions } = this.state;
        const { width } = cardProportions;
        this.setState(prevState => ({ xPosition: prevState.xPosition += width }));
    }

    handleSlideRight = () => {
        const { cardProportions } = this.state;
        const { width } = cardProportions;
        this.setState(prevState => ({ xPosition: prevState.xPosition -= width }));
    }

    render() {
        const { handleSlideLeft, handleSlideRight } = this;
        const { cardProportions, xPosition } = this.state;
        const {
            cardsLength,
            containerClass,
            contentLoading,
            sliderDisabled
        } = this.props;
        const { width } = cardProportions;
        if (!sliderDisabled) {
            return (
                <div>
                    <div className={css(styles.cardSliderContainer)}>
                        <div
                            className={css(styles.cardSlider, styles.cardSlider_enableCarouselMd, styles.cardSlider_enableCarouselLg)}
                            style={{
                                transform: `translateX(${xPosition}%)`
                            }}
                        >
                            <CardList
                                cardProportions={cardProportions}
                                containerClass={containerClass}
                                contentLoading={contentLoading}
                                sliderDisabled={sliderDisabled}
                                width={width}
                            />
                        </div>
                    </div>
                    {
                        xPosition < 0 ?
                            <FloatingChevron
                                clickAction={handleSlideLeft}
                                direction="left"
                            /> : null
                    }
                    {
                        xPosition > Math.ceil(
                            (-(width * ((cardsLength) - (Math.ceil(100 / width)))))
                        ) ?
                            <FloatingChevron
                                clickAction={handleSlideRight}
                                direction="right"
                            /> : null
                    }
                </div>
            );
        }
        return (
            <div>
                <div className={css(styles.cardSliderContainer)}>
                    <div
                        className={css(
                            styles.cardSlider,
                            styles.cardSlider_disableSliderXs,
                            styles.cardSlider_disableSliderSm,
                            styles.cardSlider_disableSliderMd,
                            styles.cardSlider_disableCarouselLg
                        )}
                    >
                        <CardList
                            cardProportions={cardProportions}
                            containerClass={containerClass}
                            contentLoading={contentLoading}
                            sliderDisabled={sliderDisabled}
                            width={width}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

CardSlider.defaultProps = {
    containerClass: 'responsiveContainer_search'
};

const mapStateToProps = ({ searchResults }) => ({
    cardsLength: getCardsLength(searchResults)
});

export default connect(mapStateToProps)(CardSlider);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardSlider.jsx